module.exports = __webpack_public_path__ + "img/product-5-50.png?160d3f24f31322095adc1b3630625d7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product-5-50.png
// module id = 230
// module chunks = 0